import React from "react";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";
import { stringFieldDefault } from "components/Utility";
import { getMailingAddressFields } from "typeConstants/mCardDefinitions/addressFields";

class MailingAddress extends React.Component {

  constructor(props) {
    super(props);
    this.getFields = this.getFields.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.setCardControls = this.setCardControls.bind(this);

    this.cardControlMethods = null;
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isUpdating && prevProps.isUpdating) {
      this.props.getData(this.props.controlNumber);
    }
  }

  setCardControls(cm) {
    this.cardControlMethods = cm;
  }

  getFields() {
    const { address, county, rawAddress } = this.props;
    return getMailingAddressFields({
      address,
      county,
      rawAddress,
    });
  }

  handleEdit(arr, obj) {
    if (this.cardControlMethods.runValidation(true)) {
      this.props.update(this.props.controlNumber, obj);
    }
  }

  render() {
    const { className } = this.props;
    return (
      <MCard
        title="Mailing Address"
        className={className}
        fields={this.getFields()}
        isEditable={this.props.isEditable}
        onEditFinished={this.handleEdit}
        getControlMethods={this.setCardControls}
      />
    );
  }
}

MailingAddress.defaultProps = {
  address: stringFieldDefault,
  rawAddress: []
};

MailingAddress.propTypes = {
  address: PropTypes.string,
  className: PropTypes.string,
  controlNumber: PropTypes.number,
  county: PropTypes.string,
  isEditable: PropTypes.bool,
  rawAddress: PropTypes.object,
  update: PropTypes.func,
  isUpdating: PropTypes.bool,
  getData: PropTypes.func,
};

export default MailingAddress;
